import GridNoColumnsSplash from './grid-no-columns-splash';

export default GridNoColumnsSplash;